var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.306 2.439c0-.626.507-1.133 1.133-1.133H7.08a.98.98 0 0 0 .976.898h3.57a.98.98 0 0 0 .977-.898h4.12c.625 0 1.132.507 1.132 1.133v19.573H1.306V2.439Zm0 20.879v4.118c0 .626.507 1.133 1.133 1.133h14.284c.626 0 1.133-.507 1.133-1.133v-4.118H1.306ZM2.439 0A2.439 2.439 0 0 0 0 2.439v24.997a2.439 2.439 0 0 0 2.439 2.439h14.284a2.439 2.439 0 0 0 2.439-2.439V2.44A2.439 2.439 0 0 0 16.723 0H2.44ZM9.58 24.573c.45 0 .816.365.816.816v.017a.816.816 0 0 1-1.632 0v-.017c0-.45.365-.816.816-.816Z",
    fill: "currentColor"
  })));
};
export default SvgPhone;